import { useState, useRef, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
    Box, Button, ButtonGroup, Card, CardContent, CardHeader, Chip,
    CircularProgress,
    Grid2 as Grid,
    Tooltip,
} from '@mui/material';
import { AccountCircle, Add, Cancel, Check, CheckBox, CleanHands, ClearAll, Delete, Download, Edit, FormatListNumbered, Functions, Info, Message, MilitaryTech, PictureAsPdf, PlayArrow, QrCode } from '@mui/icons-material';
import { checkComponentPresence, propComparator, } from "../utils/ui_utils";

import DeleteconfirmationSection from "../components/DeleteConfirmationSection";
import { delete_award_template, get_award_template_list } from "../FirebaseUtils/dbSettings"
import { useEvent } from "../context/eventContext";
import { useAuth } from "../core/AuthProvider";
import { TemplateAwardDialog } from "../modals/TemplateAwardDialog";
import { award_filter_subdict } from '../definitions/match';
import { globalstyles } from "../lib/definitions";

export const TemplateAwardSection = () => {

    const dialogRef = useRef()
    const { user } = useAuth()
    const childRefDelete = useRef()
    const { selEvent } = useEvent()
    const [element_list, setElementList] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const handleNew = () => {
        dialogRef.current.onNew()
    }

    const handleEdit = (r, i) => {
        dialogRef.current.onEdit(r, i)
    }

    const handleDelete = (r, i) => {
        const cb = () => {
            delete_award_template(user.uid, r.id)
            setElementList(lst => {
                let _el = [...lst]
                _el.splice(i, 1)
                return _el
            })
        }
        childRefDelete.current.confirmDelete('Cancella Template premio', `Sei sicuro di voler cancellare il template premio: <b>${r.name}</b>`, cb)
    }


    const reloadFn = async (el) => {
        setIsLoading(true)
        if (el) {
            setElementList(lst => {
                const c = checkComponentPresence(el, element_list, 'id')
                let _el = [...lst]
                if (c >= 0) {
                    _el.splice(c, 1, el)
                }
                return _el

            })


        } else {
            const data = await get_award_template_list()
            setElementList(data.sort(propComparator('name')))

        }
    }



    useEffect(() => {
        console.log(selEvent.id)
        reloadFn()

    }, [selEvent])


    useEffect(() => {
        if (element_list.length > 0) {
        }
        console.log("------element list", element_list.length)
        setIsLoading(false)

    }, [element_list])



    return (
        <Box sx={{ textAlign: 'center', p: 1 }}>

            <DeleteconfirmationSection ref={childRefDelete} />
            <TemplateAwardDialog ref={dialogRef} reloadFn={reloadFn} event_id={selEvent.id} />
            {isLoading ?
                <CircularProgress />
                :
                <Card sx={{ border: '1px solid lightblue', mt: 1 }}>
                    <CardContent>
                        <Grid container spacing={2} sx={{ background: 'lightblue', p: 0.5, borderTopLeftRadius: 5, borderTopRightRadius: 5 }}>
                            <Grid size={"grow"} sx={{ fontSize: '1.2em', fontWeight: 'bold', textAlign: 'left' }}>
                                Lista template premi
                            </Grid>
                            <Grid size={"auto"} sx={{ textAlign: 'right' }}>
                                <Button onClick={handleNew} variant="contained" size="small" startIcon={<Add />}>nuovo template </Button>
                            </Grid>
                        </Grid>

                        {element_list?.length > 0 ?
                            <>
                                <Grid container sx={{ backgroundColor: 'lightgrey' }}>
                                    <Grid size="grow">
                                        nome
                                    </Grid>
                                    <Grid size="grow">
                                        premi
                                    </Grid>
                                    <Grid size={3} sx={{ textAlign: 'right' }}>
                                    </Grid>

                                </Grid>

                                <Grid >
                                    {element_list.map((s, k) => (
                                        <OneTemplate_award
                                            key={k}
                                            template_award={s}
                                            index={k}
                                            handleEdit={handleEdit}
                                            handleDelete={handleDelete}
                                        />
                                    ))}
                                </Grid>
                            </>
                            :
                            <Grid >
                                Nessun soggetto ancora inserito
                            </Grid>
                        }
                    </CardContent>
                </Card>
            }

        </Box >
    );
}



const OneTemplate_award = ({ template_award, index, handleDelete, handleEdit }) => {

    return (
        <Grid container sx={{ borderTop: '1px solid black', pt: 1, mt: 1 }}>
            <Grid size={"grow"}>
                {template_award.name}
            </Grid>
            <Grid size={"grow"}>
            
            {template_award.value?.map((a, k) => (
                <Grid key={k} container sx={globalstyles.list_row}>
                    <Grid size={"grow"} >
                        {a.award_name}
                        {a.from_other_data &&
                            <Tooltip title="da dati esterni">
                                <Functions />
                            </Tooltip>
                        }
                    </Grid>
                    <Grid size={"grow"}>
                            {a.has_position ?
                                <>
                                    <Tooltip title="usa posizioni">
                                        <FormatListNumbered />
                                    </Tooltip>
                                </> :
                                <Tooltip title="premio singolo">
                                    <MilitaryTech />
                                </Tooltip>
                            }
                    </Grid>
                    <Grid size={"grow"}>
                        {a.point_list?.map((p, kk) => (
                            <Chip key={kk} size="small" label={p} />
                        ))}
                    </Grid>
                    <Grid size={"grow"}>
                        {a.filter_data_list?.sort().map((f, k) => (
                            <Chip key={k} label={award_filter_subdict[f].label} color={award_filter_subdict[f].color} size="small" />
                        ))}
                    </Grid>
                </Grid>
            ))}
            </Grid>

            <Grid size={3} sx={{ textAlign: 'right' }}>
                <ButtonGroup size="small">
                    <Tooltip title="modifica">
                        <Button color="warning" onClick={() => handleEdit(template_award, index)} startIcon={<Edit color="warning" />}></Button>
                    </Tooltip>
                    <Tooltip title="cancella">
                        <Button color="error" onClick={() => handleDelete(template_award, index)} startIcon={<Delete />}></Button>
                    </Tooltip>
                </ButtonGroup>

            </Grid>
        </Grid>

    )
}


